import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import API_ENDPOINTS from "../config/api";
import { useNavigate } from "react-router-dom";
import { storeToken, getValidToken } from "../utils/auth";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  width: 100%;
  background-color: #013566;
`;

const LoginDiv = styled.div`
  background-color: white;
  -webkit-box-shadow: 8px 8px 24px -15px rgba(66, 68, 90, 1);
  -moz-box-shadow: 8px 8px 24px -15px rgba(66, 68, 90, 1);
  box-shadow: 8px 8px 24px -15px rgba(66, 68, 90, 1);
  padding: 2rem;
  border-radius: 1rem;
  width: 580px;

  h1 {
    font-size: 2rem;
    font-weight: 500;
  }

  input {
    width: 100%;
    margin-top: 2rem;
    padding: 1rem;
    border: none;
    outline: none;
    border-bottom: 1px solid #eee;
  }

  button {
    outline: none;
    border: none;
    border-radius: 1rem;
    padding: 0.75rem;
    text-transform: uppercase;
    font-size: 0.95rem;
    background-color: #013566;
    color: white;
    text-align: center;
    width: 200px;
    margin: 2rem auto 0;
    display: block;
    cursor: pointer;

    &:hover {
      color: orange;
    }
  }

  .error {
    color: red;
    font-size: 0.85rem;
    margin-top: 1rem;
    text-align: center;
  }

  .success {
    color: green;
    font-size: 0.85rem;
    margin-top: 1rem;
    text-align: center;
  }
`;

const Logo = styled.img`
  width: 100px;
  height: auto;
`;

interface Props {
  setSnackbar: any;
}

const Login: React.FC<Props> = ({ setSnackbar }) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  // Redirect if already logged in with valid token
  useEffect(() => {
    const token = getValidToken();
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError(null);
    setSuccess(null);
  };

  const handleSubmit = async () => {
    const { email, password } = formData;

    if (!email || !password) {
      setError("Both fields are required.");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(API_ENDPOINTS.LOGIN, {
        email,
        password,
      });

      storeToken(response?.data?.token);
      navigate("/dashboard");
      setSnackbar({
        isOpen: true,
        message: "Logged In Succesfully",
        severity: "success",
      });
    } catch (err) {
      setError("An error occurred. Please try again later.");
      setSuccess(null);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <Container>
      <LoginDiv>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h1>Login</h1>
          <Logo
            src="/MRG-iQ-Black.png"
            alt="MRG-iQ Logo"
          />
        </div>

        <input
          placeholder="Email"
          type="text"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        <input
          placeholder="Password"
          type="password"
          name="password"
          value={formData.password}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />

        <button disabled={loading} onClick={handleSubmit}>
          {loading ? "Loading.." : "Login"}
        </button>

        {error && <div className="error">{error}</div>}
        {success && <div className="success">{success}</div>}
      </LoginDiv>
    </Container>
  );
};

export default Login;
